import "core-js/modules/es6.object.freeze";
import { colors, colorsRefresh } from '../colors';
import { shadows, shadowsRefresh } from '../shadows';
export var navigation = Object.freeze({
  height: '48px',
  heightNumber: 48,
  creatorMenuOffsetWidth: '64px',
  creatorMenuOffsetWidthNumber: 64,
  creatorMenuOffsetWidthUnits: 8,
  creatorMenuExpandedWidth: '200px',
  creatorMenuExpandedWidthNumber: 200,
  subMenuWithCreatorMenuOffsetWidthNumber: 224,
  subMenuWidth: '170px',
  subMenuWidthNumber: 170,
  creatorMenuLinkHeight: '70px',
  mobileMenuLinkHeight: '60px',
  boxShadow: shadows.box["default"],
  rightBoxShadow: "2px 0 0 0 " + colors.shadow,
  navbarOffsetHeight: '48px'
});
/**
 * @todo Rethink whether these values should live in the theme.
 */

export var navigationRefresh = Object.freeze({
  height: '64px',
  heightNumber: 64,
  creatorMenuOffsetWidth: '208px',
  creatorMenuOffsetWidthNumber: 208,
  creatorMenuOffsetWidthUnits: 26,
  creatorMenuExpandedWidth: '208px',
  creatorMenuExpandedWidthNumber: 208,
  subMenuWithCreatorMenuOffsetWidthNumber: 208,
  subMenuWidth: '0px',
  subMenuWidthNumber: 0,
  creatorMenuLinkHeight: '70px',
  mobileMenuLinkHeight: '60px',
  boxShadow: shadowsRefresh.box["default"],
  rightBoxShadow: "2px 0 0 0 " + colorsRefresh.shadow,
  navbarOffsetHeight: '48px'
});